import type { FC } from 'react';
import { useZohoActivity } from '../../util/hooks/useZoho';
import { JOB_STATUS } from '../../util/Constants';
import { formatDate } from '../../util/functions/UniversalFunctions';
import StatusPill from './StatusPillAndCopyRow';

const ActivityTab: FC = () => {
  const { data } = useZohoActivity();

  if (!data) return <div className="h-48 rounded-xl bg-slate-200 animate-pulse" />;

  return (
    <div className="flex flex-col gap-5">
      <div className="grid gap-4 sm:grid-cols-3">
        {[
          ['Sent, last 30 days', data.sent30d],
          ['Scheduled', data.scheduled],
          ['Failed, last 30 days', data.failed30d],
        ].map(([label, value]) => (
          <div
            key={label as string}
            className="bg-white rounded-xl border border-slate-200 p-4 flex flex-col gap-1"
          >
            <span className="text-xs text-slate-500">{label}</span>
            <strong className="text-2xl font-bold text-slate-900">
              {value as number}
            </strong>
          </div>
        ))}
      </div>

      <section className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        {data.results.length === 0 ? (
          <p className="p-8 text-center text-sm text-slate-500">
            No messages yet. They appear here as events arrive.
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 border-b border-slate-200">
                <tr>
                  {['Automation', 'Customer', 'Status', 'When'].map((h) => (
                    <th
                      key={h}
                      className="px-4 py-3 text-left font-medium text-slate-600"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {data.results.map((r) => (
                  <tr key={r.id} className="hover:bg-slate-50">
                    <td className="px-4 py-3">
                      <span className="text-slate-900">{r.flow}</span>
                      <div className="text-xs text-slate-500">{r.ref}</div>
                    </td>
                    <td className="px-4 py-3">
                      <span className="text-slate-900">{r.name ?? '—'}</span>
                      <div className="text-xs text-slate-500">{r.phone}</div>
                    </td>
                    <td className="px-4 py-3">
                      <StatusPill kind={JOB_STATUS[r.status] ?? 'muted'}>
                        {r.status.toLowerCase()}
                      </StatusPill>
                      {r.error && (
                        <div className="text-xs text-slate-500 mt-0.5">
                          {r.error}
                        </div>
                      )}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-slate-600">
                      {formatDate(r?.sentAt ?? r?.runAt ?? 0)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
};

export default ActivityTab;